import React from "react";
import Format from "../../common/Format";
import Convert from "../../common/Convert";
import InputBase from "./InputBase";
import {
    Input,Label
} from "reactstrap";
import historykana from 'historykana';
import {type} from '../../variables/column_map';

export default class InputText extends InputBase {
    static defaultProps = {
        label:'テキスト',
        labelOn:false,
        name:'',
        className:'',
        style:{},
        maxlength : 1024,
        multiline: false,
        enterSearchFlag: false,
        rootData:{
            values:{},
            errors:{},
            requiredData:{}
        },
        hasKanaInput:false,
    }
    constructor(props) {
        super(props);
        let defaultParentStyle = {padding:0, margin:0, position:"relative", borderColor:"red"};

        this.handle_blur = this.handle_blur.bind(this);
        this.enterSearch = this.enterSearch.bind(this);
        this.handle_change = this.handle_change.bind(this)
        this.kanaValidateCallback = this.kanaValidateCallback.bind(this)
        this.state = {
            history:[],
            kana:"",
            disabled: (this.props.disabled)? this.props.disabled: false,
            parentStyle:(this.props.parentStyle)? {...defaultParentStyle, ...this.props.parentStyle}:{...defaultParentStyle},
        }
    }

    componentDidMount(){
        document.getElementById(this.props.name).touch=()=>{
            const value = this.selfDom.current.props.defaultValue
            this.handle_blur({target:{value:(value?String(value):"")}})
        }
    }
    
    handle_change(e){
        if (this.props.hasKanaInput){
            const value = e.target.value
            const newHistory = [...this.state.history,value]
            const kana = this.hiraToKana(historykana(newHistory))
            this.setState({
                history:newHistory,
                kana
            })
        }
    }

    hiraToKana(hira) {
        return hira.replace(/[\u3041-\u3096]/g, function(match) {
            var chr = match.charCodeAt(0) + 0x60;
            return String.fromCharCode(chr);
        });
    }
    
    enterSearch(e,name){
        var ENTER = 13;
        if(this.props.enterSearchFlag == false){
            if (e.keyCode == ENTER && this.props.multiline !== true) {
                super.focusNextNode(e);
            }
            return
        }
        
        if (e.keyCode == ENTER) {
            const parentTypeKey = type[this.props.name]
            const formattedValue = this.formatValue(parentTypeKey, e.target.value)
            e.target.value = formattedValue
            this.props.enterCallback&&this.validate(formattedValue, this.props.enterCallback)
        }        
    }

    handle_blur(e) {
        const parentTypeKey = type[this.props.name]
        const trimmedValue = this.trim(e.target.value)
        const formattedValue = this.formatValue(parentTypeKey, trimmedValue)
        e.target.value = formattedValue
        this.validate(formattedValue, this.props.hasKanaInput ? this.kanaValidateCallback : undefined)
    }

    formatValue(parentTypeKey, value) {
        let formattedValue = "";

        switch(parentTypeKey){
            case "text_ja_2" :
                formattedValue = value;
                break;
            case "zip_1" :
                formattedValue = Format.format_zip(value);
                break;
            case "id_2":
                formattedValue = Format.format_hankaku_lower(value);
                break;
            default :
                formattedValue = Format.format_hankaku(value);
                break;
        }
        return formattedValue;
    }

    kanaValidateCallback(){
        const {
            kana, 
            history
        } = this.state
        const{
            name,
            rootData:{
                requiredData,
                errors,
                values
            }
        } = this.props
        if (history.length>0){
            const columnObject = Convert.key_split(name)
        
            this.props.validateCallback({
                values:{
                    ...values,
                    [`${columnObject.column}_kana`]:this.trim(kana)
                },
                errors,
                requiredData,
            });
        }
    }

    render() {
        const{
            className,
            placeholder,
            disabled=this.state.disabled,
            name,
            label,
            labelOn,
            multiline,
            rootData:{
                requiredData,
                errors,
                values
            },
            showValidateMessage=true
        } = this.props
        
        const columnObject = Convert.key_split(name)
        const defaultValue = values&&values[columnObject.column]
        const validate_message = errors&&errors[columnObject.column]

        return (
            <>
                {
                    (labelOn) &&
                    <Label for={name} className="search-text-order">
                        {label} 
                         ：
                    </Label>
                }
                <div style={this.state.parentStyle}>
                    <Input
                        ref={this.selfDom}
                        onKeyDown={(e) => this.enterSearch(e,name)} 
                        type={multiline ? "textarea" : "text"} 
                        name={name} 
                        id={name} 
                        placeholder={placeholder?placeholder:(label + "を入力してください")} 
                        onChange={this.handle_change} 
                        onBlur={disabled?()=>{}:this.handle_blur} 
                        defaultValue={defaultValue} 
                        className={`tabable `+className} 
                        {...(multiline?{readOnly:disabled}:{disabled:disabled})}
                        {...(!showValidateMessage && validate_message instanceof Array && validate_message.length>0 
                            && {style:{border:"2px solid red"}})}
                    />
                    {defaultValue!=undefined&&!disabled&&defaultValue!==""&&<svg 
                        style={{
                            position: "absolute",
                            right: "8px",
                            top: 0,
                            height: "calc(2.25rem + 2px)",
                        }}
                        height="20" 
                        width="20" 
                        viewBox="0 0 20 20" 
                        aria-hidden="true" 
                        focusable="false" 
                        className="css-6q0nyr-Svg text-clear-btn"
                        onClick={()=>{this.validate("")}}
                    >
                        <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                    </svg>}
                </div>
                {
                    showValidateMessage && validate_message instanceof Array && validate_message.length>0 &&
                    <p id={name} style={{ color: "red" }}>{validate_message.length>0?validate_message[0]:validate_message}</p>
                }
            </>
        );
    }
}
